import { PageLayout, PageLayoutHeader, PageLayoutRow, PageLayoutTitle } from 'components';
import React from 'react';

export class Settlements extends React.Component {
    public componentDidMount(): void {
        document.title = 'ENTER Platform - Settlements';
    }

    public render(): React.ReactElement {
        return (
            <PageLayout>
                <PageLayoutRow>
                    <PageLayoutHeader>
                        <PageLayoutTitle>Settlements</PageLayoutTitle>
                    </PageLayoutHeader>
                </PageLayoutRow>
            </PageLayout>
        );
    }
}
